// @ts-check

import React from 'react';

import CircleUserIcon from '@liquidweb-dev/undercurrent/icons/lucide/CircleUser';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import FancyHighlight from 'components/standard/FancyHighlight';
import RestrictionPaper from '../RestrictionPaper';
import RestrictionWrapper from '../RestrictionWrapper';

/** @param {import('@liquidweb-dev/undercurrent/Stack').StackProps} props */
const RestrictionUnauthorized = ({ sx, ...rest }) => {
	return (
		<RestrictionWrapper
			sx={combineSx(
				({ vars }) => ({
					background: `linear-gradient(165deg, ${vars.palette.uc.bg.main} 10.48%, ${vars.palette.uc.bg.weak} 55.27%, ${vars.palette.uc.bg.main} 115.69%)`,
				}),
				sx,
			)}
			{...rest}
		>
			<RestrictionPaper>
				<FancyHighlight
					sx={({ vars }) => ({
						display: 'flex',
						gap: 100,
						alignItems: 'center',
						width: 'fit-content',
						borderColor: vars.palette.uc.border.weak,
						backgroundColor: vars.palette.uc.bg.weak,
						color: vars.palette.uc.text.weak,
					})}
				>
					<CircleUserIcon sx={{ width: '20px', height: '20px' }} />
					<Typography variant="title-sm">Unauthorized</Typography>
				</FancyHighlight>

				<Stack sx={{ gap: 200 }}>
					<Typography variant="body-md" sx={{ fontWeight: 500 }}>
						It looks like your user role doesn&apos;t have permission to view
						this page.
					</Typography>

					<Typography
						variant="body-sm"
						sx={{ color: ({ vars }) => vars.palette.uc.text.medium }}
					>
						If you need to update or change your access, please contact the
						account owner or your administrator.
					</Typography>
				</Stack>
			</RestrictionPaper>
		</RestrictionWrapper>
	);
};

export default RestrictionUnauthorized;
